import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useStoreState } from 'easy-peasy';

import MainSwitch from '@components/navigation/MainSwitch';
import { GTM } from '@app/gtm';
import Hotjar from '@app/hotjar';
import { selectorUser } from '@model/User';
import Meta from '@components/Meta/Meta';
import { HelmetProvider } from 'react-helmet-async';
import { SVGSprite } from '@reverse-hr/design-system';

const App = () => {
  const {
    locale,
    email: userEmail,
    type: userType,
  } = useStoreState(selectorUser);

  useEffect(() => {
    if (
      userType &&
      userType !== 'manager' &&
      process.env.NODE_ENV !== 'development'
    ) {
      GTM.initialize({ locale, userEmail });
      Hotjar.initialize();
    }
  }, [userType]);

  return (
    <div className="customer">
      <HelmetProvider>
        <Meta />
        <BrowserRouter basename={__ENVIRONMENT_CONFIG__.PUBLIC_URL}>
          <MainSwitch />
        </BrowserRouter>
        <SVGSprite />
      </HelmetProvider>
    </div>
  );
};

export default App;
